<div #scrollContainer class="rx-scrollable-container">
  <ng-content></ng-content>
  <div class="rx-scrollable-loading" *ngIf="loading"></div>
</div>
